export default {"src":"/_next/static/media/more.8d299635.svg","height":28,"width":28};